import dayjs, { type Dayjs } from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

import { DATE_FORMAT } from "../../../../utils/date/date.ts"

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * The Actual End to fill in when a milestone is marked Completed and has none
 * yet (EAD-1389 item 12). A milestone whose planned end already passed is
 * taken to have finished on plan, so it gets the planned end — stamping today
 * instead anchors every Finish→Start successor on the day of the edit and
 * shows a delay that never happened. Otherwise it finished today, read in the
 * account's timezone rather than the browser's or UTC. Either way it is only
 * a default; the field stays editable.
 */
export const completedActualEndDefault = (
  plannedEnd: Dayjs | null,
  accountTimezone?: string | null
): string => {
  const today = (
    accountTimezone ? dayjs().tz(accountTimezone) : dayjs()
  ).format(DATE_FORMAT)
  if (!plannedEnd?.isValid()) return today

  const planned = plannedEnd.format(DATE_FORMAT)
  return planned < today ? planned : today
}
